export { default as SimpleLayout } from './SimpleLayout';
export { default as AppLayout } from './AppLayout';
export { default as AuthLayout } from './AuthLayout';
export { default as AnonymousLayout } from './AnonymousLayout';
export { default as ProtectedRoute } from './ProtectedRoute';
export { default as ScrollAreaLayout } from './ScrollAreaLayout';
export { default as Layout } from './Layout';
export { default as ErrorPage } from './ErrorPage';
export { default as HeaderWithBreadcrumbs } from './HeaderWithBreadcrumbs';
